import { ProductCategory } from '@ridango/core';
import { ProductCategoriesPartialStoreState, PRODUCT_CATEGORIES_STATE_KEY } from './product-categories.reducer';

export const getLoaded = (state: ProductCategoriesPartialStoreState) => {
    return state[PRODUCT_CATEGORIES_STATE_KEY].loaded;
};

export const getError = (state: ProductCategoriesPartialStoreState) => state[PRODUCT_CATEGORIES_STATE_KEY].error;

export const getCategoryTypes = (state: ProductCategoriesPartialStoreState) =>
    state[PRODUCT_CATEGORIES_STATE_KEY].types;

export const getCategoriesByType = (type, state: ProductCategoriesPartialStoreState) => {
    return state[PRODUCT_CATEGORIES_STATE_KEY].categoryIdsByType[type].map(
        (id) => state[PRODUCT_CATEGORIES_STATE_KEY].byId[id]
    );
};

export const getSubCateories = (categoryId: number) => (state: ProductCategoriesPartialStoreState) => {
    const category = state[PRODUCT_CATEGORIES_STATE_KEY].byId[categoryId] as ProductCategory;

    return (
        category?.categories
            ?.map((cat) => state[PRODUCT_CATEGORIES_STATE_KEY].byId[cat.category_id])
            .filter((cat) => cat !== undefined) ?? []
    );
};

export const getSelectedCategoryByType = (type, state: ProductCategoriesPartialStoreState) => {
    return state[PRODUCT_CATEGORIES_STATE_KEY].byId[state[PRODUCT_CATEGORIES_STATE_KEY].selectedCategoryIdByType[type]];
};

export const getSelectedCategoryIdByTypeObject = (state: ProductCategoriesPartialStoreState) =>
    state[PRODUCT_CATEGORIES_STATE_KEY].selectedCategoryIdByType;

export const getAllCategories = (state: ProductCategoriesPartialStoreState) => {
    return Object.values(state[PRODUCT_CATEGORIES_STATE_KEY].byId ?? {});
};
